import { action, makeObservable, observable } from 'mobx';
import React, { useContext } from 'react';
import { AppStateType } from '../../../common/types/appState';
import { IAppState } from '../../../common/types/socket';
import { Api } from './Api';

export class AppState {
    public appState: IAppState<AppStateType> | null;
    public serverOnline: boolean = true;

    public constructor(api: Api) {
        makeObservable(this, {
            appState: observable,
            serverOnline: observable,
            setAppState: action,
            setServerOnline: action,
            logout: action,
        });

        this.appState = null;

        setInterval(async () => {
            try {
                const response = await api.post('/status', null);
                if (response.status !== 200) {
                    this.setAppState(null);
                    this.setServerOnline(false);
                    console.log('Server offline');
                } else {
                    this.setAppState(response.data.content);
                    this.setServerOnline(true);
                }
            } catch {
                this.setAppState(null);
                this.setServerOnline(false);
                console.log('Server offline');
            }
        }, 5000);
    }

    public setAppState = (appState: IAppState<AppStateType> | null) => {
        this.appState = appState;
    };

    public setServerOnline = (serverOnline: boolean) => {
        this.serverOnline = serverOnline;
    };

    public logout = () => {
        this.appState = null;
    };
}

const appStateContext = React.createContext<AppState>(undefined!);
export const AppStateProvider = appStateContext.Provider;

export function useAppState() {
    return useContext(appStateContext);
}
